import * as queryString from 'query-string'

import { Consent, userHasOptedOutOfCookiesForCategory } from './consent'
import axiosVerbose from './axios/axiosVerbose'
import { logError } from './errors'
import { removeCookie } from './cookieHelper'

const affiliateRecorder = (location: Location, referrer: string) => {
  const userHasOptedOutOfCookiesForAffiliate = userHasOptedOutOfCookiesForCategory(
    Consent.marketing
  )

  if (!userHasOptedOutOfCookiesForAffiliate) {
    const query = queryString.parse(location.search)
    query.url = location.href
    query.referrer = referrer

    axiosVerbose
      .get(`/consociate/indite?${queryString.stringify(query)}`)
      .then(res => {
        if (res.data && res.data.redirect) {
          window.location.href = res.data.redirect_url
        }
      })
      .catch(logError)
  }

  handleOptedOutEvent(location)
}

const handleCookiebotAcceptDeclineEvent = (location: Location) => () => {
  if (userHasOptedOutOfCookiesForCategory(Consent.marketing)) {
    const cookieOptions = { path: '/', domain: location.host }
    removeCookie({
      itemKey: 'click_id',
      cookieOptions
    })
    removeCookie({
      itemKey: 'referring_user',
      cookieOptions
    })
    removeCookie({
      itemKey: 'clickthrough_id',
      cookieOptions
    })
  }
}

const handleOptedOutEvent = (location: Location) => {
  if (typeof window !== 'undefined') {
    window.addEventListener(
      'CookiebotOnAccept',
      handleCookiebotAcceptDeclineEvent(location)
    )
    window.addEventListener(
      'CookiebotOnDecline',
      handleCookiebotAcceptDeclineEvent(location)
    )
  }
}

export default affiliateRecorder
